const CustomBarLabel = ({
  x, y, width, height, value, total, index,
  chartType = 'verticalBar',
  lineIndex = 0  // Nuevo parámetro para identificar la línea en gráficos de comparación
}) => {
  // 1. Condición de Ocultamiento Principal
  if (value === 0 || value === null || value === undefined) return null;

  const absValue = Math.abs(value);

  // 2. Manejo de barSize (CLAVE para Gráficos de Línea)
  let barSize = 0; // Se inicializa a 0. Esto previene que las condiciones de tamaño afecten a las líneas.

  if (chartType === 'horizontalBar') {
    barSize = width;
  } else if (chartType === 'verticalBar' || chartType === 'posNegBar') {
    barSize = height;
  }

  // 3. Ocultar si la barra es muy pequeña (solo aplica si barSize > 0)
  if (barSize > 0) {
    if (barSize < 10 && total > 15) return null; // Barras muy pequeñas en gráficos con muchos datos
    if (barSize < 5) return null; // Siempre ocultar en barras extremadamente pequeñas
  }

  // 4. Formatear el número
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 100000) {
      return (num / 1000).toFixed(0) + 'K';
    } else if (num >= 10000) {
      return num.toLocaleString('es-CO', { maximumFractionDigits: 0 });
    }
    return num.toString();
  };

  const label = formatNumber(absValue);
  const length = label.length;

  // 5. Funciones de Cálculo de Fuente (ajustadas para manejar barSize=0)
  const getBaseFontSize = () => {
    if (total > 50) return 3;
    if (total > 35) return 4;
    if (total > 25) return 5;
    if (total > 18) return 6;
    if (total > 12) return 7;
    if (total > 8) return 8;
    return 9;
  };

  const adjustForLength = (base) => {
    if (length >= 8) return Math.max(base - 3, 4);
    if (length >= 6) return Math.max(base - 2, 4);
    if (length >= 5) return Math.max(base - 1, 5);
    return base;
  };

  const adjustForBarSize = (base) => {
    // Si barSize es 0 (línea) o es lo suficientemente grande, no ajustamos.
    if (barSize === 0 || barSize > 35) return base;

    // Si barSize es pequeño (barras), reducimos la fuente.
    if (barSize < 15) return Math.max(base - 3, 4);
    if (barSize < 25) return Math.max(base - 2, 4);
    if (barSize < 35) return Math.max(base - 1, 5);

    return base;
  };

  const baseFont = getBaseFontSize();
  const lengthAdjusted = adjustForLength(baseFont);
  const finalFont = adjustForBarSize(lengthAdjusted); // Aplica ajustes de tamaño de barra o mantiene el ajuste de longitud

  const minOffset = chartType === 'verticalBar' ? 6 : 5;
  const offset = Math.max(finalFont * 0.6, minOffset);

  let posX, posY, anchor;

  // 6. Lógica de Posicionamiento

  if (chartType === 'horizontalBar') {
    posX = x + width + offset;
    posY = y + height / 2 + finalFont / 3;
    anchor = 'start';

  } else if (chartType === 'verticalBar') {
    posX = x + width / 2;
    posY = y - offset;
    anchor = 'middle';

  } else if (chartType === 'posNegBar') {
    posY = y + height / 2 + finalFont / 3;
    if (value >= 0) {
      // Valores positivos: label FUERA a la derecha
      posX = x + width + offset;
      anchor = 'start';
    } else {
      // Valores negativos: label DENTRO a la izquierda
      const safeMargin = offset + 5;
      posX = x - safeMargin;
      anchor = 'end';
    }

  } else if (chartType === 'line') {
    // Lógica para Líneas: Basada en X, Y (coordenadas del punto)
    const baseOffset = offset;

    // Para evitar la sobreposición entre dos líneas diferentes,
    // usamos separación vertical Y horizontal

    if (lineIndex === 0) {
      // Primera línea: a la izquierda del punto, cerca
      posX = x - 8;  // Desplazamiento horizontal a la izquierda
      posY = y - baseOffset * 1.2;  // Cerca del punto
      anchor = 'end';  // Anclaje al final (derecha del texto)
    } else {
      // Segunda línea: a la derecha del punto, a la misma altura
      posX = x + 8;  // Desplazamiento horizontal a la derecha
      posY = y - baseOffset * 1.2;  // A la misma altura que la primera
      anchor = 'start';  // Anclaje al inicio (izquierda del texto)
    }
  }

  // 7. Renderizado Final
  const textColor = value < 0 ? '#DC2626' : 'var(--color-text-primary)';

  return (
    <text
      x={posX}
      y={posY}
      textAnchor={anchor}
      fill={textColor}
      fontSize={finalFont}
      fontWeight="600"
      pointerEvents="none"
      style={{ userSelect: 'none' }}
    >
      {label}
    </text>
  );
};

export default CustomBarLabel;